import React, {Fragment} from "react";
import TinymceFloatPanel from "../common/TinymceFloatPanel";
import {getCategoryDisplayName} from "../../lib/PostUtils"

export function CategoryListPanel(props) {
  const { categories, onSelect } = props;
  return (
    <TinymceFloatPanel>
      <CategoryItem categoryId={0} name={'카테고리 없음'} viewChanel={null} onSelect={onSelect} />

      {categories.filter(c => c.id >= 0).map(category =>
        <Fragment key={category.id}>
          <CategoryItem categoryId={category.id} name={getCategoryDisplayName(category)} viewChanel={category.viewChannel} onSelect={onSelect} />

          {category.children && category.children.map(sub =>
            <CategoryItem key={sub.id} categoryId={sub.id} name={`- ${getCategoryDisplayName(sub)}`} viewChanel={sub.viewChannel} onSelect={onSelect} />
          )}
        </Fragment>
      )}
    </TinymceFloatPanel>
  );
}

function CategoryItem(props) {
  const { categoryId, name, viewChanel, onSelect } = props;
  return (
    <div key={categoryId} className="mce-menu-item mce-menu-item-normal mce-stack-layout-item" role="menuitem" onClick={e => onSelect(categoryId, viewChanel)}>
      <span className="mce-text">{name}</span>
    </div>
  );
}
